<template>
  <div class="end-screen">
    <h1 class="end-screen__title">
      Tadaa
    </h1>
    <p>{{ winnerPlayer.name }} heeft gewonnen!</p>
    <Button
      text="Speel opnieuw de game!"
      v-on:buttonClick="$router.push('board')"
    />
  </div>
</template>

<script>
import { mapGetters } from 'vuex';
import Button from '../components/shared/Button.vue';

export default {
  components: {
    Button
  },
  computed: mapGetters(['winnerPlayer'])
};
</script>

<style lang="scss" scoped>
.end-screen {
  &__title {
    margin-top: 0;
  }

  &__select {
    display: flex;
    width: calc(100% + 20px);
    margin: -10px;
  }
}
</style>
